module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Clothes/Socks-26c1cf18e65f60cff40152b9acf6156c.svg";